import React from 'react';
import { useState, useEffect } from 'react';
import { Tabs, Table, Badge } from 'antd';
import type { TabsProps } from 'antd';
import { Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import SweetAlert from "sweetalert2"
import { Chip, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Box, Button } from '@mui/material';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ColumnsType } from 'antd/es/table';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { DataSaverOn } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Utilisateur from '../../../../Models/Utilisateur';
import 'react-toastify/dist/ReactToastify.css';
import PlanCp from '../../../../Types/Plancp';
import { Commis } from '../../../../Types/Commis';
import SelectOption from '../../../SelectOption';
import DataSelect from '../../../../Types/DataSelect';
import { getLastDayOfMonth } from '../../../../Functions/Traitement/getLastDayOfMonth';
import INTDEB from '../../../../Models/INTDEB';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Tab2 from './Tab2';
import Data from '../../../../Data/Data.json';
import SelectMultipleOption from '../../../SelectMultipleOption';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import DataAgence from '../../../../Types/DataAgence';
import { json } from 'stream/consumers';
import {  PrintCalculEOMDirect } from '../../../../utilitaires/globalFunction';
import { useAgence } from '../../../../AgenceContext';


const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;

const dataOption2: DataSelect[] = [
  { label: "1--JANVIER", value: "01" },
  { label: "2--FÉVRIER", value: "02" },
  { label: "3--MARS", value: "03" },
  { label: "4--AVRIL", value: "04" },
  { label: "5--MAI", value: "05" },
  { label: "6--JUIN", value: "06" },
  { label: "7--JUILLET", value: "07" },
  { label: "8--AOÛT", value: "08" },
  { label: "9--SEPTEMBRE", value: "09" },
  { label: "10--OCTOBRE", value: "10" },
  { label: "11--NOVEMBRE", value: "11" },
  { label: "12--DECEMBRE", value: "12" }
]
//client Physique
const CalInteret = () => {
  const auth = useAuthUser()
  const Branch=useAgence();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  // USER TOKEN
  const authHeader = useAuthHeader();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [, forceUpdate] = useState({});
  const [selectedRowKeysAgc, setSelectedRowKeysAgc] = useState<React.Key[]>([]);
  const [selectedRowKeysCom, setSelectedRowKeysCom] = useState<React.Key[]>([]);
  const [selectedRowKeysPlancp, setSelectedRowKeysPlancp] = useState<React.Key[]>([]);
  const hasSelected = selectedRowKeysCom.length && selectedRowKeysPlancp.length && selectedRowKeysAgc.length > 0;

  const [DataAgen, SetDataAgen] = useState<string[]>([]);
  const [DataCom, SetDataComs] = useState<string[]>([]);
  const [DataPlan, SetDataPlan] = useState<string[]>([]);
  const [DataPlancp, SetDataDataPlancp] = useState<PlanCp[]>([]);
  const [DataCommis, SetDataCommis] = useState<Commis[]>([]);
  const [DataAggl, SetDataAggl] = useState<DataAgence[]>([]);


  const [start, setstart] = useState(false);
  const [value, setValue] = React.useState(1);
  const [Intcredit, SetIntCredit] = useState<any>('');
  const navigate = useNavigate();

  useEffect(
    () => {
      form.setFieldValue('Mois', user.datjour && user.datjour !== '' ? user.datjour.substring(5, 7) : '');
      if (start === false) {
        LoaDataAgence();
        GetIntComEOM(value);

        setstart(true)
      }
      forceUpdate({});
    },
    []);

  const column: ColumnsType<INTDEB> = [
    {
      title: 'Agence ',
      dataIndex: 'AEDUCP',
      width: 150,
    },
    {
      title: 'NUMCPT',
      dataIndex: 'NODUCP',
      align: 'left',
      width: 150,
    },
    {
      title: 'NOMCPT',
      dataIndex: 'NOMCPT',
      align: 'left',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'MONTANT',
      dataIndex: 'MONTAN',
      align: 'left',
      width: 100,
    },
    {
      title: 'TXMONT',
      dataIndex: 'TXMONT',
      width: 100,
    },
    {
      title: 'SENSEC',
      dataIndex: 'SENSEC',
      width: 100,
    },
    {
      title: 'LIBELLE',
      dataIndex: 'LIBELL',
      ellipsis: true,
      width: 300,
    },
    {
      title: 'REPECE',
      dataIndex: 'REPECE',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'montfrais',
      dataIndex: 'montfrais',
      width: 100,
    },
    {
      title: 'solvei',
      dataIndex: 'solvei',
      width: 100,
    },
    {
      title: 'UTISAI',
      dataIndex: 'UTISAI',
      width: 100,
    }
  ];


  const colComis: ColumnsType<Commis> = [
    {
      title: 'CODCOM',
      dataIndex: 'CODCOM',
      ellipsis: true,
      width: 50,
    },
    {
      title: 'LIBELLE',
      dataIndex: 'LIBELL',
      ellipsis: true,
      width: 150,
    }
    // ,
    // {
    //   title: 'TXDEBI',
    //   dataIndex: 'TXDEBI',
    //   ellipsis: true,
    //   width: 100
    // }
  ]

  const Colplancp: ColumnsType<PlanCp> =
    [
      {
        title: 'IDPLAN',
        dataIndex: 'IDPLAN',
        width: 50
      },
      {
        title: 'Libelle',
        dataIndex: 'LIBELL',
        ellipsis: true,
        width: 150,
      }
      ,
      // {
      //   title: 'TYPCPT',
      //   dataIndex: 'TYPCPT',
      //   width: 70
      // },
      // {
      //   title: 'FRECAL',
      //   dataIndex: 'FRECAL',
      //   width: 70
      // },
      // {
      //   title: 'DATCRE',
      //   dataIndex: 'DATCRE',
      //   width: 100
      // }
    ]

  const ColAgence: ColumnsType<DataAgence> =
    [
      {
        title: 'CODE',
        dataIndex: 'CodeAgence',
        width: 50
      },
      {
        title: 'Libelle',
        dataIndex: 'Libelle',
        ellipsis: true,
        width: 50,
      },
      {
        title: 'Journée',
        align: 'center',
        ellipsis: true,
        width: 80,
        render: (text: any, record: any) => (
          <Box sx={{ alignItems: 'center' }} gap={'1em'} >
            <Badge status='success' color={record.cdetat == "50" ? 'green' : record.cdetat == "53" ? 'red' : 'orange'} size='default' count={record.cdetat == "50" ? 'Open' : 'Close'}> </Badge>
          </Box>
        )
      },
      {
        title: 'Date Veille',
        dataIndex: 'DATVEIL',
        ellipsis: true,
        width: 50,
      },
      {
        title: 'Date jour',
        dataIndex: 'DATJOUR',
        ellipsis: true,
        width: 50,
      },

    ]


  const onFinish = (values: any) => {

    let Year = user.datjour.substring(0, 4);
    let LastDay = getLastDayOfMonth(parseInt(Year), values.Mois.replaceAll('0', ''));
    let DateDebut = '01-' + values.Mois + '-' + Year;
    let DatFin = LastDay + '-' + values.Mois + '-' + Year;
    if (value === 3) {
      LastDay = getLastDayOfMonth(parseInt(Year), values.MoisFin.replaceAll('0', ''));
      DatFin = LastDay + '-' + values.MoisFin + '-' + Year;
    }

    let Titre: string = "";
    let TitreCal: string = "";
    let TitreAcpt: string = "";
    let today = new Date(parseInt(Year), values.Mois.replaceAll('0', '') - 1, LastDay);
    const monthNameShort = today.toLocaleString('fr-fr', { month: 'long' });


    switch (value) {
      case 1:
        {
          Titre = "INTERETS DEBITEUR DE " + monthNameShort + " " + Year;
          TitreCal = "Calcul des intérêts débiteurs ";
          TitreAcpt = "Voulez-vous calculer les intérêts débiteurs du Mois de " + monthNameShort.toUpperCase() + " Des  Agences " + JSON.stringify(DataAgen).replaceAll("\"", "").replaceAll("[", "").replaceAll("]", "") + " ? ";
        
          break;
        }
      case 2:
        {
          Titre = "COMMISSION DE " + monthNameShort + " " + Year;
          TitreCal = "Calcul des commissions ";
          TitreAcpt = "Voulez-vous calculer les commissions du Mois de " + monthNameShort.toUpperCase() + " Des  Agences " + JSON.stringify(DataAgen).replaceAll("\"", "").replaceAll("[", "").replaceAll("]", "") + " ? ";
          break;
        }
      case 3:
        {
          Titre = "INTERETS CREDITEUR DU " + " " + DateDebut + " AU " + " " + DatFin;
          TitreCal = "Calcul des intérêts créditeurs ";
          TitreAcpt = "Voulez-vous calculer les intérêts créditeurs  du " + " " + DateDebut + " au " + " " + DatFin + " Des  Agences " + JSON.stringify(DataAgen).replaceAll("\"", "").replaceAll("[", "").replaceAll("]", "") + " ? ";
          break;
        }
    }

    SweetAlert.fire({
      title: TitreCal,
      text: TitreAcpt,
      showCancelButton: true,
      color: "green",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then((res) => {
      if (res.isConfirmed) {
        setLoading(true);
        let data = Crypter.encrypt(JSON.stringify(value));

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.CaculInterets,
          headers: {
            'Authorization': authHeader(),
            'Content-Type': 'application/json',
            'CyphelistAgence': Crypter.encrypt(JSON.stringify(DataAgen)),
            'CypherAgence': Crypter.encrypt(user.codage),
            'CyphelistPlancp': Crypter.encrypt(JSON.stringify(DataPlan)),
            'CyphelistCion': Crypter.encrypt(JSON.stringify(DataCom)),
            'CypherdatDebut': Crypter.encrypt(DateDebut),
            'CypherdatFin': Crypter.encrypt(DatFin),
            'CypherdatImput': Crypter.encrypt(DatFin),
            'CypherUtisai': Crypter.encrypt(user.coduti),
            'CypherOption': Crypter.encrypt(value.toString()),
          },
          data: data
        };

        axios.request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
              if (res.StatutCode == 200) {
                toast.success(res.Result);
                if (res.Result.length > 0) {

                  let Datat: INTDEB[] = [];
                  let TotalC: number = 0;

                  res.Result.map((data: any, indice: number) => {
                    TotalC = TotalC + data.MONTAN;
                    Datat.push({
                      key: indice,
                      AEDUCP: data.AEDUCP,
                      NODUCP: data.NODUCP,
                      numcli: data.numcli,
                      NOMCPT: data.NOMCPT,
                      LECECP: data.LECECP,
                      MONTAN: formatNumber(data.MONTAN ? data.MONTAN : ''),
                      TXMONT: formatNumber(data.TXMONT ? data.TXMONT : ''),
                      TYPOPE: data.TYPOPE,
                      SENSEC: data.SENSEC,
                      CDLBEC: data.CDLBEC,
                      DATECR: data.DATECR,
                      LIBELL: data.LIBELL,
                      REPECE: data.REPECE,
                      DEDEVR: data.DEDEVR,
                      CDEEXO: data.CDEEXO,
                      CDDEVS: data.CDDEVS,
                      CODANA: data.CODANA,
                      INTAUX: data.INTAUX,
                      INTYPE: data.INTAUX,
                      TYPCALC: data.TYPCALC,
                      CODIFIE: data.CODIFIE,
                      montfrais: formatNumber(data.montfrais ? data.montfrais : ''),
                      solvei: formatNumber(data.solvei ? data.solvei : ''),
                      UTISAI: data.UTISAI
                    })
                  })

                  localStorage.removeItem((Data.LocalVariable.tabINTDEB));
                  localStorage.setItem(Data.LocalVariable.tabINTDEB, JSON.stringify({ "columns": column, "data": Datat, 'Total': formatNumber(TotalC), 'Titre': Titre,"FileName":Titre }));
                  //navigate("/Calculinteret/PrintINTDEB");
                   PrintCalculEOMDirect(
                                                         Branch.agence?.BANQUE ?? '', 
                                                          Branch.agence?.VILLE ?? '',
                                                          Branch.agence?.BPOSTE ?? '',  
                                                          Branch.agence?.TELEPH ?? '',              
                                                         user.codage,
                                                         user.agence,
                                                         user.nomuti ?? '',
                                                         user.coduti,
                                                         value.toString(),
                                                         "PDF"
                                                    )
                }
                else SweetAlert.fire({ title: 'Error', text: "Aucun élément retourné", icon: "warning" })
              }
              else {
                SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            console.log(error);
            SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
          });
      }
    })
  };

  const GetIntComEOM = async (Option: number) => {
    setLoading(true)

    let datatCom: Commis[] = [];
    let datatPlancp: PlanCp[] = [];

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetIntComEOM,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherCodu': Crypter.encrypt(user.coduti),
        'CypherAgence': Crypter.encrypt(user.codage),
        'CypherOption': Crypter.encrypt(Option.toString()),
      }
    };

  
    await
      axios(config)
        .then((response) => {
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode === 200) {
              let datas = res.Result;
              datas.Table1.map((data: any, indice: number) => {
                datatCom.push({
                  key: indice,
                  CODCOM: data.CODCOM,
                  LIBELL: data.LIBELL,
                  TXDEBI: data.TXDEBI
                })
              })

              datas.Table2.map((data: any, indice: number) => {
                datatPlancp.push({
                  key: indice,
                  IDPLAN: data.IDPLAN,
                  LIBELL: data.LIBELL,
                  TXDEBI: data.TXDEBI,
                  TYPCPT: data.TYPCPT,
                  FRECAL: data.FRECAL,
                  DATCRE: data.DATCRE ? (new Date(data.DATCRE.substring(0, 10))).toLocaleDateString("fr") : '',
                })
              })

              SetDataCommis(datatCom);
              SetDataDataPlancp(datatPlancp);
            }
          }
        }).catch((error) => {
          console.log(error)
          setLoading(true)
          SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
        })
    setLoading(false)
  }

  const LoaDataAgence = async () => {
    const datat: DataAgence[] = [];

    //console.log(Crypter.encrypt(JSON.stringify(data)))

    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetDetailEod,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherCodu': Crypter.encrypt(user.coduti),
        'CypherAgence': Crypter.encrypt(user.codage),
        'CypherOption': Crypter.encrypt('7')
      }
    };
    await
      axios(config)
        .then((response) => {
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        
            if (res.StatutCode == 200) {
              let datas = res.Result;

              if (datas.length === 0) {
                //console.log("aucun élément ");
                //SetData(datat)
              }
              else {
                datas.map((data: any, indice: number) => {
                  datat.push({
                    key: indice,
                    CodeAgence: data.CODAGE,
                    Libelle: data.LIBELLE,
                    cdetat: data.CDETAT,
                    CDETATCAI:data.CDETATCAI,
                    DATJOUR: data.DATJOUR?(new Date(data.DATJOUR.substring(0, 10))).toLocaleDateString("fr"):'',
                    DATVEIL:data.DATVEIL?(new Date(data.DATVEIL.substring(0, 10))).toLocaleDateString("fr"):'',
                  });
                })
                SetDataAggl(datat);
              }
            }
          }
        }).catch((error) => {
          console.log(error)
          // SweetAlert.fire({title: "Error", text : error})
        })
  };

  const onSelectChangeAgc = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeysAgc(newSelectedRowKeys);
    let datat: string[] = [];

    newSelectedRowKeys.map((index: any, number: number) => {
      datat.push(DataAggl[index].CodeAgence);
    })

    SetDataAgen(datat);
  };


  const onSelectChangeCom = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeysCom(newSelectedRowKeys);
    let datat: string[] = [];

    newSelectedRowKeys.map((index: any, number: number) => {
      datat.push(DataCommis[index].CODCOM);
    })
    SetDataComs(datat);
  };

  const onSelectChangePlancp = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeysPlancp(newSelectedRowKeys);
    let datat: string[] = [];
    newSelectedRowKeys.map((index: any, number: number) => {
      datat.push(DataPlancp[index].IDPLAN);
    })
    SetDataPlan(datat);
  };

  const rowSelectionAgc = {
    selectedRowKeysAgc,
    onChange: onSelectChangeAgc,
    getCheckboxProps: (record: DataAgence) => {
      if (record.CDETATCAI === '53' && record.cdetat === '53' && loading === false)
        return {
          disabled: false,
        };
      else
        return {
          disabled: true,
        };
    },
  };


  const rowSelectionCom = {
    selectedRowKeysCom,
    onChange: onSelectChangeCom,
  };

  const rowSelectionPlancp = {
    selectedRowKeysPlancp,
    onChange: onSelectChangePlancp,
  };

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: number,
  ) => {
    if (newAlignment > 0 && newAlignment !== value) {
      setValue(newAlignment);
      GetIntComEOM(newAlignment);

      if (newAlignment === 3) {
        SetIntCredit(<SelectOption Option={dataOption2} width={2} label='Mois Fin' Size={'middle'} name="MoisFin" />)
        let moisdebut = form.getFieldValue('Mois');
        form.setFieldValue('MoisFin', user.datjour && user.datjour !== '' ? (parseInt(moisdebut) + 5) < 10 ? ('0' + parseInt(moisdebut + 5)) : (parseInt(moisdebut) + 5) : '');
      }
      else SetIntCredit("")
    }
  };


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined />
          TRAITEMENT DES INTERETS  DE FIN DU MOIS
        </span>
      ),
      children:
        <>
          <div className='tabItem' >
            <ToastContainer />
            <Box fontStyle="inherit" className='border-left border' width={"95%"} position={"absolute"}>
              <ToggleButtonGroup value={value} onChange={handleChange} sx={{ width: '80%' }} aria-label="Platform" color="primary" exclusive>
                <ToggleButton value={1}>  Interet  Débiteur  </ToggleButton>
                <ToggleButton value={2}>  Commission         </ToggleButton>
                <ToggleButton value={3}>  Interet Créditeur </ToggleButton>
              </ToggleButtonGroup>
              {/* <SelectMultipleOption DefaulValue={user.codage} width={2} label='Agence' Size={'middle'} name="Agence" Parametre={searchAgence} /> */}
              <SelectOption Option={dataOption2} width={2} label='Mois' Size={'middle'} name="Mois" />
              {Intcredit}
              <Table sticky={true}
                    rowSelection={{ ...rowSelectionAgc }}
                    size='small' loading={loading} columns={ColAgence} pagination={false} style={{ width: '100%' }} scroll={{ y: 120, x: 400 }} dataSource={DataAggl} />
               
              <Box style={{ display: 'flex' }} gap={'1%'}  >
                <Box fontStyle="inherit" className='border-left' width={'50%'}>
                  <Table sticky={true} loading={loading}  rowSelection={{ ...rowSelectionCom }} size='small' columns={colComis} pagination={false} style={{ width: '100%' }} scroll={{ y: 200, x: 400 }} dataSource={DataCommis} />
                </Box>
                <Box fontStyle="inherit" className='border-left' width={'50%'}>
                  <Table sticky={true}  loading={loading}rowSelection={{ ...rowSelectionPlancp }} size='small' columns={Colplancp} pagination={false} style={{ width: '100%' }} scroll={{ y: 200, x: 400 }} dataSource={DataPlancp} />
                </Box>
              </Box>
              <Box sx={{ justifyContent: 'space-between', display: 'flex' }} >
                
                <Box>
                  <Button disabled={!hasSelected || loading === true ? true : false} size='medium' variant="contained" type="submit" startIcon={<DataSaverOn />}>ENREGISTRER</Button>
                </Box>
                <Box>
                  <Button disabled={!hasSelected || loading === true ? true : false}
                  onClick={() => {
                                     PrintCalculEOMDirect(
                                                         Branch.agence?.BANQUE ?? '', 
                                                          Branch.agence?.VILLE ?? '',
                                                           Branch.agence?.BPOSTE ?? '',  
                                                            Branch.agence?.TELEPH ?? '',              
                                                         user.codage,
                                                         user.agence,
                                                         user.nomuti ?? '',
                                                         user.coduti,
                                                         value.toString(),
                                                         "PDF"
                                                    )
                                      }}
                   size='medium' variant="contained"  startIcon={<DataSaverOn />}>APERCU</Button>
                </Box>
              </Box>
            </Box>
          </div>
        </>
    },
    {
      key: '2',
      label: (
        <span>
          <UserOutlined />
          Visualisation des Caluls
        </span>
      ),
      children: <Tab2 form={form} />
    }
  ];

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];
    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + "");
    })
    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
  };


  return (
    <div className='tab'>
      <Box className='formTitle'>
        <Breadcrumbs aria-label="breadcrumb">
          <StyledBreadcrumb component="a" href="/jjh" label="Home" icon={<HomeIcon fontSize="small" />} />
          <StyledBreadcrumb component="a" href="#" label="Gestion" />
          <StyledBreadcrumb label="Ouverture de journee" deleteIcon={<ExpandMoreIcon />} />
        </Breadcrumbs>
      </Box>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinishFailed={onFinishFailed} onFinish={onFinish} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='clientP'><div > <Tabs size='large' type="card" items={items} /></div><div>
          </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}

export default CalInteret;

